import { render, staticRenderFns } from "./FlexGroup.vue?vue&type=template&id=0611cc89&scoped=true"
import script from "./FlexGroup.vue?vue&type=script&lang=ts"
export * from "./FlexGroup.vue?vue&type=script&lang=ts"
import style0 from "./FlexGroup.vue?vue&type=style&index=0&id=0611cc89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0611cc89",
  null
  
)

export default component.exports